// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { groupBy } from 'lodash';
import { THEY_REQUESTED, YOU_REQUESTED, FRIEND } from 'app/constants/friendStatusTypes';
import friendsInGroupSelector from 'app/selectors/friends/friendsInGroupSelector';
import GroupDetails from 'app/components/friends/groups/GroupDetails';
import Card from 'app/components/commons/Card';

type Props = {
  className?: string,
  children?: any,
  group: FriendGroup,
  groupMembers?: Array<iFriendUser>,
  hideMembers?: boolean,
  onClick: (id: number) => void,
};

class GroupCard extends Component<Props> {
  props: Props;

  static defaultProps = {
    children: null,
    className: undefined,
    groupMembers: [],
    hideMembers: false,
  };

  render() {
    const {
      groupMembers,
      group,
      className,
      onClick,
      children,
      hideMembers,
    } = this.props;
    const friendGroups = groupBy(groupMembers, 'status');
    const friends = friendGroups[FRIEND] || [];
    const youRequested = friendGroups[YOU_REQUESTED] || [];
    const theyRequested = friendGroups[THEY_REQUESTED] || [];

    return (
      <Card
        className={className}
        onClick={() => onClick(group.id)}
      >
        <GroupDetails
          numMembers={hideMembers ? null : friends.length}
          numYouRequests={hideMembers ? null : youRequested.length}
          numTheyRequests={hideMembers ? null : theyRequested.length}
          name={group.name}
        />
        {children}
      </Card>
    );
  }
}

function mapStateToProps(state: GlobalState, props: Props) {
  return {
    groupMembers: friendsInGroupSelector(state, props.group.id),
  };
}

export default connect(mapStateToProps)(GroupCard);
